import styled from 'styled-components';
//components
import { Column, Row } from 'components/Layout/Grid';
import { Button } from 'components/Button';
import Input from 'components/Input';

export const ContainerSearch = styled(Row)`
  > div {
    align-items: flex-end;
  }
  
  @media only screen and (max-width: 715px) {
    flex-direction: column;
    gap: 15px;
    flex: 1;

    > div + div {
      margin-left: 0;

      > div {
        width: 100%;
      }

      > button {
        width: 30%;
        margin-top: 18px;
      }
    }
  }

  @media only screen and (max-width: 370px) {
    > div {
      flex-direction: column;

      > div, > div + div {
        width: 100%;
      }

      > button {
        width: 100%;
        margin: 10px 0 0;
      }
    }
  }
`;

export const ColumnVerticalLine = styled(Column)`
  &:before {
    content: "";
    width: 2px;
    height: 60px;

    border-radius: 5px;

    background: #287C87;
  }
  flex-direction: row;

  @media only screen and (min-width: 1024px) {
    margin-left: 2.4em;
    margin-right: 2.4em;
  }


  @media only screen and (max-width: 1023px) {
    margin-left: 1.4em;
    margin-right: 1.4em;
  }

  @media only screen and (max-width: 767px) {
    margin-left: .4em;
    margin-right: .4em;
  }

  @media only screen and (max-width: 735px) {
    display: none;
  }
`;

export const SearchInput = styled(Input).attrs(() => ({
  placeholder: "Digite o termo e pressione enter para pesquisar",
  name: "BuscaOrigemRazaoSocialStatus",
  className: "bg-white w-100 quotesSearch"
}))``;

export const CustomIcon = styled.img`
  margin-right: 8px;
`;

export const SearchButton = styled(Button).attrs({
  className: 'StatusFilterButton button bg-greenDarkViveo'
})`
  width: 70px;
  height: 40px;
  z-index: 99999;
  background: ${props => props.disabled ? "#BEBEBE" : "#0E4C54"};

  margin-right: 16px;

  @media screen and (max-width: 735px) {
    width: 70px;
    margin-right: 10px;
  }

  @media screen and (max-width: 715px) {
    margin-right: 0;
  }

  &:disabled {
    opacity: 1;
  }

  > div.show {
    opacity: 1 !important;
  }
`;